(ns manatee.auth.token
  (:refer-clojure :exclude [peek])
  (:require #?@(:clj  [[clojure.java.io :as io]
                       [cheshire.core :as json]]
                :cljs [[goog.crypt.base64 :as b64]])
            [clojure.string :as str]
            [taoensso.timbre :as log])
  #?(:clj (:import java.util.Base64)))

(defn peek
  [token]
  (try
    (-> (str/split token #"\." 3)
        (second)
        (str/replace #"_" "/")
        (str/replace #"\-" "+")
        #?@(:clj  [(#(let [bs (.decode (Base64/getDecoder) ^String %)]
                       (with-open [rdr (io/reader bs)]
                         (json/parse-stream rdr keyword))))]
            :cljs [(b64/decodeString)
                   (js/JSON.parse)
                   (js->clj :keywordize-keys true)]))
    (catch #?(:clj Exception :cljs :default) _
      (log/error "Error decoding auth token:" {:token token}))))
